const DRACO_DECODER_SCRIPT = 'draco_decoder.js'
const DRACO_ASSET_BASE_PATHS = [
  '/draco',
  '/public/draco',
]

type FetchLike = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>

export interface ResolvedDracoAsset {
  assetBaseUrl: string
  scriptUrl: string
  scriptText: string
}

function trimTrailingSlash(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value
}

function buildAssetBaseUrl(origin: string, candidatePath: string): string {
  return trimTrailingSlash(new URL(candidatePath, origin).toString())
}

export async function resolveDracoAsset(
  fetchFn: FetchLike,
  origin: string
): Promise<ResolvedDracoAsset> {
  const failures: string[] = []

  for (const candidatePath of DRACO_ASSET_BASE_PATHS) {
    const assetBaseUrl = buildAssetBaseUrl(origin, candidatePath)
    const scriptUrl = assetBaseUrl + '/' + DRACO_DECODER_SCRIPT

    try {
      const response = await fetchFn(scriptUrl)
      if (!response.ok) {
        failures.push(scriptUrl + ' -> ' + response.status + ' ' + response.statusText)
        continue
      }

      return {
        assetBaseUrl: assetBaseUrl,
        scriptUrl: scriptUrl,
        scriptText: await response.text(),
      }
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error)
      failures.push(scriptUrl + ' -> ' + message)
    }
  }

  throw new Error('Unable to resolve Draco decoder asset. Tried: ' + failures.join('; '))
}
